const setCopyPlace = {
  true: 'Branch',
  false: 'Leaf',
  text: 'selected',
  text1: 'added to clipboard'
};

export default setCopyPlace;
